import { render, staticRenderFns } from "./ChevronDownIcon.vue?vue&type=template&id=a474ded8"
import script from "./ChevronDownIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports